/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { Dropdown } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../assets/images/commen-visible-icon.svg';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  InterestCalcHead,
  FederalFamilyHead,
  FederalPercentHead,
} from './tablehead';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
} from '../../../SharedModules/utilities/utilities';
import { closeTab } from '../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { redirectURLLink } from '../../../SharedModules/CommonUtilities/commonUtilities';
import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { getCheckPay } from './store/actions';

const IntShareTab = (props) => {
  const dispatch = useDispatch();
  const {
    gridData,
    frameworkComponents,
    disableIntCalAdd,
    intRecordAdd,
    intRecordDelete,
    intFedaralFrameworkComponents,
    intFedFamilyFrameworkComponents,
    handleFullScreen,
    disableAdd,
    isEnablebyRole,
  } = props;
  const int_calc = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.int_calc
  );

  const [intCalcData, setIntCalcData] = React.useState([]);
  const [federalData, setFederalData] = React.useState([]);
  const [fedFamilyData, setFedFamilyData] = React.useState([]);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [deleteMsg, setDeleteMsg] = React.useState('');
  const [fedFullscreen, setFedFullScreen] = React.useState(false);
  const [calcFullscreen, setCalcFullScreen] = React.useState(false);
  const [fedFamFullscreen, setFedFamFullScreen] = React.useState(false);

  React.useEffect(() => {
    if (gridData) {
      let {
        rpcCalcPctVOIntShareFedaralList,
        rpcParamVoIntShareIntCalList,
        rpcParamVoIntShareFedaralFamiliList,
      } = gridData;
      if (rpcParamVoIntShareIntCalList)
        setIntCalcData([...rpcParamVoIntShareIntCalList]);
      if (rpcCalcPctVOIntShareFedaralList)
        setFederalData([...rpcCalcPctVOIntShareFedaralList]);
      if (rpcParamVoIntShareFedaralFamiliList)
        setFedFamilyData([...rpcParamVoIntShareFedaralFamiliList]);
    }
  }, [gridData]);

  React.useEffect(() => {
    if (!int_calc) dispatch(getCheckPay('INT_CALC_METHOD_CD'));
  }, []);

  return (
    <>
      {!fedFamFullscreen && !fedFullscreen && (
        <fieldset
          className="custom-fieldset mt-3"
          data-testid="interest-calculation"
          style={{ height: 'auto' }}
        >
          <legend className="same-font-family">Interest Calculation</legend>
          {/* {!calcFullscreen && (
             <div className="btn-wrapper mb-2">
               <div className="float-right">
                 <Button
                   className="btn btn-success btn-search"
                   onClick={() => intRecordAdd('intcalc')}
                   disabled={disableIntCalAdd}
                 >
                   <SVGComponent iconName="Icon-outline-add-circle1" /> Add
                 </Button>
                 <Button
                   className="btn btn-cancel"
                   onClick={() => {
                     if (
                       intCalcData.filter((o) => o.delete === true).length > 0
                     ) {
                       setDeleteMsg('intcalc');
                       setDeleteModal(true);
                     }
                   }}
                   disabled={disableIntCalAdd}
                 >
                   <SVGComponent iconName="Icon-cancel" /> Delete
                 </Button>
               </div>
             </div>
           )} */}
          <div class="clearfix" />
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-rbtprg-tblselectbox">
            <TableGrid
              data-testid="intcalc"
              // rowData={intCalcData}
              rowData={
                intCalcData &&
                intCalcData?.map((item) => {
                  const firstDropdownVal = int_calc?.filter((x) => {
                    return (
                      x.codeValueID &&
                      x.codeValueID?.codeValue === item.calcMethodCd
                    );
                  });
                  if (firstDropdownVal && firstDropdownVal.length > 0) {
                    item.intCalcMethodDD = `${
                      firstDropdownVal[0].codeValueID &&
                      firstDropdownVal[0].codeValueID.codeValue
                    } - ${firstDropdownVal[0].shortDescription}`;
                  } else {
                    item.intCalcMethodDD = null;
                  }
                  return item;
                })
              }
              gridHeight={calcFullscreen ? '70vh' : 360}
              handleFullScreenViewClick={() => {
                setCalcFullScreen(!calcFullscreen);
                handleFullScreen(!calcFullscreen);
              }}
              noGlobalSort
              disableAdd={disableAdd || disableIntCalAdd || !isEnablebyRole}
              fullScreenView={calcFullscreen}
              hideColumnsInPdf={['delete']}
              addButtonText="Add Interest Calculation"
              handleAddNewRow={(e) => intRecordAdd('intcalc')}
              columnDefs={InterestCalcHead}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              exportFile
              fileName="Interest Calculation"
              onCellFocused={onCellFocused}
              frameworkComponents={frameworkComponents}
            />
          </div>
          <div className="clearfix" />
        </fieldset>
      )}
      {!fedFamFullscreen && !calcFullscreen && (
        <fieldset
          className="custom-fieldset mt-3"
          data-testid="federal"
          style={{ height: 'auto' }}
        >
          <legend className="same-font-family">Federal %</legend>
          {/* {!fedFullscreen && (
             <div className="btn-wrapper mb-2">
               <div className="float-right">
                 <Button
                   className="btn btn-success btn-search"
                   onClick={() => intRecordAdd('intfed')}
                 >
                   <SVGComponent iconName="Icon-outline-add-circle1" /> Add
                 </Button>
                 <Button
                   className="btn btn-cancel"
                   onClick={() => {
                     if (
                       federalData.filter((o) => o.delete === true).length > 0
                     ) {
                       setDeleteMsg('intfed');
                       setDeleteModal(true);
                     }
                   }}
                 >
                   <SVGComponent iconName="Icon-cancel" /> Delete
                 </Button>
               </div>
             </div>
           )} */}
          <div class="clearfix" />
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-rbtprg-tblselectbox">
            <TableGrid
              data-testid="uracalculation"
              rowData={federalData}
              gridHeight={fedFullscreen ? '70vh' : 360}
              handleFullScreenViewClick={() => {
                setFedFullScreen(!fedFullscreen);
                handleFullScreen(!fedFullscreen);
              }}
              noGlobalSort
              disableAdd={disableAdd || !isEnablebyRole}
              fullScreenView={fedFullscreen}
              hideColumnsInPdf={['delete']}
              addButtonText="Add Federal %"
              handleAddNewRow={(e) => intRecordAdd('intfed')}
              columnDefs={FederalPercentHead}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              exportFile
              fileName="Federal"
              onCellFocused={onCellFocused}
              frameworkComponents={intFedaralFrameworkComponents}
            />
          </div>
          <div className="clearfix" />
        </fieldset>
      )}
      {!calcFullscreen && !fedFullscreen && (
        <fieldset
          className="custom-fieldset mt-3"
          data-testid="federal-family"
          style={{ height: 'auto' }}
        >
          <legend className="same-font-family">
            Federal Family Planning %
          </legend>
          {/* {!fedFamFullscreen && (
             <div className="btn-wrapper mb-2">
               <div className="float-right">
                 <Button
                   className="btn btn-success btn-search"
                   onClick={() => intRecordAdd('intfedfmly')}
                 >
                   <SVGComponent iconName="Icon-outline-add-circle1" /> Add
                 </Button>
                 <Button
                   className="btn btn-cancel"
                   onClick={() => {
                     if (
                       fedFamilyData.filter((o) => o.delete === true).length > 0
                     ) {
                       setDeleteMsg('intfedfmly');
                       setDeleteModal(true);
                     }
                   }}
                 >
                   <SVGComponent iconName="Icon-cancel" /> Delete
                 </Button>
               </div>
             </div>
           )} */}
          <div class="clearfix" />
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-rbtprg-tblselectbox">
            <TableGrid
              data-testid="updateura"
              rowData={fedFamilyData}
              gridHeight={fedFamFullscreen ? '70vh' : 360}
              handleFullScreenViewClick={() => {
                setFedFamFullScreen(!fedFamFullscreen);
                handleFullScreen(!fedFamFullscreen);
              }}
              noGlobalSort
              disableAdd={disableAdd || !isEnablebyRole}
              fullScreenView={fedFamFullscreen}
              hideColumnsInPdf={['delete']}
              addButtonText="Add Federal Family Planning %"
              handleAddNewRow={(e) => intRecordAdd('intfedfmly')}
              columnDefs={FederalFamilyHead}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              exportFile
              fileName="Federal Family Planning"
              onCellFocused={onCellFocused}
              frameworkComponents={intFedFamilyFrameworkComponents}
            />
          </div>
          <div className="clearfix" />
        </fieldset>
      )}
      {/* <SaveCancelPopup
         open={deleteModal}
         data-test="cancelPopup"
         title="Delete"
         onConfim={() => {
           setDeleteModal(false);
           intRecordDelete(deleteMsg);
         }}
         onCancel={(e) => setDeleteModal(false)}
         moduleName={`selected row(s)`}
       /> */}
    </>
  );
};

export default IntShareTab;
